import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    attrs: {
      "size": "small",
      "title": "筛选"
    }
  }, [_c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('a-row', {
    staticClass: "fold"
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "日期范围",
      "prop": "time"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.form.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "维修状态",
      "prop": "repairsStatus"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择维修状态"
    },
    model: {
      value: _vm.form.repairsStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "repairsStatus", $$v);
      },
      expression: "form.repairsStatus"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-select-option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("草稿")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("待受理")]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("待派单")]), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("待接单")]), _c('a-select-option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("不受理")]), _c('a-select-option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("维修中")]), _c('a-select-option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("已评价")]), _c('a-select-option', {
    attrs: {
      "value": 7
    }
  }, [_vm._v("已完成")]), _c('a-select-option', {
    attrs: {
      "value": 8
    }
  }, [_vm._v("外部维修")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "保修单号/故障描述",
      "prop": "queryStr"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入保修单号/故障描述"
    },
    model: {
      value: _vm.form.queryStr,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "queryStr", $$v);
      },
      expression: "form.queryStr"
    }
  })], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "html-type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.form.resetFields();
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _c('a-card', {
    attrs: {
      "size": "small",
      "title": "报修单列表",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "templateTable",
    attrs: {
      "dataSource": _vm.tableData,
      "columns": _vm.columns,
      "pagination": _vm.paginationTable,
      "bordered": "",
      "rowKey": "number",
      "scroll": {
        y: 500
      },
      "size": "middle",
      "loading": _vm.loading
    },
    on: {
      "change": _vm.change
    },
    scopedSlots: _vm._u([{
      key: "repairsStatus",
      fn: function fn(repairsStatus, row) {
        return [0 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("草　稿")]) : _vm._e(), 1 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待受理")]) : _vm._e(), 2 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待派单")]) : _vm._e(), 3 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待接单")]) : _vm._e(), 4 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("不受理")]) : _vm._e(), 5 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("维修中")]) : _vm._e(), 6 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("已评价")]) : _vm._e(), 7 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("已完成")]) : _vm._e(), 8 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("外部维修")]) : _vm._e()];
      }
    }, {
      key: "drafterTemp",
      fn: function fn(text, row) {
        return [_c('div', {
          staticClass: "text-ellipsis"
        }, [_vm._v(_vm._s(row.organName) + " / " + _vm._s(row.postName))])];
      }
    }, {
      key: "operation",
      fn: function fn(text, record) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', {
          key: "1"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewRigister(record);
            }
          }
        }, [_vm._v(" 查看 ")])], 1), 3 === record.repairsStatus || 5 === record.repairsStatus ? _c('a-menu-item', {
          key: "4"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.orderClick(record);
            }
          }
        }, [_vm._v("处理")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };